import { render, staticRenderFns } from "./PaymentStatusModal.vue?vue&type=template&id=542c2cfd&scoped=true&"
import script from "./PaymentStatusModal.vue?vue&type=script&lang=js&"
export * from "./PaymentStatusModal.vue?vue&type=script&lang=js&"
import style0 from "./PaymentStatusModal.vue?vue&type=style&index=0&id=542c2cfd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "542c2cfd",
  null
  
)

export default component.exports